import { PARTNER_OR_SPOUSE_TERM } from '@/components/flows/CompassFlow/constants'
import {
  PERSONAL_SITUATION_MARRIED,
  WITH_PARTNER_PERSONAL_SITUATIONS,
} from '@/components/flows/CompassFlow/steps/4_ClientDetails/constants'
import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import { GetCompassPartnersParams } from '@/types/requests/compass'
import {
  CompassPartnerCollection,
  CompassScores,
  CompassScoresWithSingleScore,
} from '@/types/responses/compass'

class CompassService {
  private endpoint = `${API_PATH_INTERNAL}/compass`

  hasSingleScore(
    scores?: Pick<
      CompassScores,
      'onTrackResilience' | 'organisedOptimised' | 'financialHealth'
    >,
  ): scores is CompassScoresWithSingleScore {
    return !!scores?.financialHealth
  }

  getPartnerOrSpouseTerm(personalSituation?: string): string {
    return personalSituation === PERSONAL_SITUATION_MARRIED
      ? PARTNER_OR_SPOUSE_TERM.spouse
      : PARTNER_OR_SPOUSE_TERM.partner
  }

  async getCompassPartners(
    companyId: number,
    params: GetCompassPartnersParams,
  ): Promise<CompassPartnerCollection> {
    const response = await apiService.get(
      `${this.endpoint}/${companyId}/partners`,
      { params },
    )

    return response.data
  }

  renderDate(options: { month?: number; year?: number }): string {
    const { month, year } = options

    if (!month || !year) {
      return 'N/A'
    }

    const date = new Date(year, month - 1, 1)

    return `${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`
  }

  hasSharedFinances(userPersonalSituation?: string): boolean {
    return !!(
      userPersonalSituation &&
      WITH_PARTNER_PERSONAL_SITUATIONS.includes(userPersonalSituation)
    )
  }
}

const compassService = new CompassService()

export default compassService
